import script from "./SendNotificationModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./SendNotificationModal.vue?vue&type=script&setup=true&lang=ts"

import "./SendNotificationModal.vue?vue&type=style&index=0&id=7b542fb9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b542fb9"]])

export default __exports__